var React = require('react');

function CrossRed (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.69351 6.2793L6.2793 7.69351L10.5722 11.9864L6.2793 16.2793L7.69351 17.6935L11.9864 13.4006L16.2793 17.6935L17.6935 16.2793L13.4006 11.9864L17.6935 7.69351L16.2793 6.2793L11.9864 10.5722L7.69351 6.2793Z","fill":"#DA0C22"}));
}

CrossRed.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CrossRed;

CrossRed.default = CrossRed;
